function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// @ts-check
import Vue from 'vue';
import { sync } from 'vuex-pathify';
import template from './genentech-thank-you.html';

var GenentechThankYou = /*#__PURE__*/function () {
  function GenentechThankYou() {
    _classCallCheck(this, GenentechThankYou);
  }

  _createClass(GenentechThankYou, null, [{
    key: "register",
    value: function register() {
      Vue.component('genentech-thank-you', {
        template: template,
        props: {
          firstname: {
            type: String
          },
          surname: {
            type: String
          },
          geneUrl: {
            type: String
          },
          geneCtaUrl: {
            type: String
          },
          labels: {
            type: Object
          }
        },
        mounted: function mounted() {
          var mainEl = document.querySelector('main');
          if (!mainEl) return;
          mainEl.style.overflow = 'hidden';
          mainEl.style.position = 'absolute';
          mainEl.style.height = '100%';
        },
        destroyed: function destroyed() {
          var mainEl = document.querySelector('main');
          if (!mainEl) return;
          mainEl.style.overflow = 'auto';
          mainEl.style.position = 'relative';
          mainEl.style.height = 'auto';
        },
        computed: {
          form: sync('forms/form'),
          genentechData: sync('forms/genentechData'),
          genentechCaseNumber: sync('forms/genentechCaseNumber'),
          complaintFormUrl: function complaintFormUrl() {
            return "".concat(this.geneUrl, "?qualityEventNumber=").concat(this.genentechCaseNumber);
          },
          showReplacementOption: function showReplacementOption() {
            if (!this.form.product || !this.genentechData.replacementProductIds || this.genentechData.replacementProductIds.length === 0) {
              return false;
            }

            return this.genentechData.replacementProductIds.includes(this.form.product.value);
          }
        }
      });
    }
  }]);

  return GenentechThankYou;
}();

export default GenentechThankYou;